<template>
  <div>
    <Header
      title="Builder"
      description="Your Go-To hub to connect with your Virtual Tech Team to check on the progress of your custom developments."
    />
    <div class="px-6 py-8 bg-white h-85vh fixed-top">
      <div class="flex">
        <div class="w-4/12 pr-4 menucontrol-scroller">
          <LeftCone />
        </div>
        <div class="w-8/12 pl-4 menucontrol-scroll">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NotificationUser from "@/views/adminPanel/pages/dashboard/NotificationUser";
import LeftCone from "./components/LeftCone";
import Header from "@/views/adminPanel/layouts/components/Header";
export default {
  data() {
    return {
      cards: [
        {
          id: "01",
          title: "Project Manager",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/ba.png",
          route: "builder-PM",
        },
        {
          id: "02",

          title: "Business Analyst",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/pm.png",
          route: "builder-BA",
        },
        {
          id: "03",

          title: "User Experience",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/ux.png",
          route: "builder-UX",
        },

        {
          id: "04",

          title: "Developer1",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/dev.png",
          route: "developer-one",
        },

        {
          id: "06",

          title: "Developer2",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/dev.png",
          route: "developer-two",
        },
        {
          id: "07",

          title: "Developer3",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/dev.png",
          route: "developer-three",
        },

        {
          id: "05",

          title: "Quality Assurance",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/qa.png",
          route: "builder-QA",
          // route: "coming",
        },
        {
          id: "08",

          title: "Cloud",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/cloud.png",
          route: "coming",
        },
      ],
      options: "",
      selectedTasklist: "",
      taskList: [],
      selectedRoute: "",
    };
  },
  components: {
    LeftCone,
    NotificationUser,
    Header,
  },
  watch: {
    selectedTasklist(newValue) {
      this.$store.commit("design/SET_SELECTED_SPRINT", newValue);
      this.getPages();
    },
  },
  methods: {
    async getPages() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await this.$store.dispatch(
            "builder/getPages",
            {
              projectId: this.selectedProject._id,
              projectName: this.selectedProject.projectName,
              tasklistID: this.selectedSprint._id,
            },
            {
              headers: {
                "community-name": this.selectedProject.projectName,
              },
            }
          );
          console.log(data, "pages");
          this.components = data.data.map((x) => ({ ...x, Hrs: 0 }));
          this.$store.commit("design/SET_COMPONENTS", data.data);
          this.$store.commit(
            "design/SET_SELECTED_COMPONENT",
            this.components[0]
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    handlescope(name) {
      this.$router.push({ name: name });
    },
    handleClick(item) {
      this.selectedRoute = item;
      this.$router.push({ name: item.route });
    },

    async getTaskList() {
      return new Promise(async (resolve, reject) => {
        try {
          // const { data } = await Repository.post(
          //   "/zoho/projects/tasks/tasklist"
          // );
          // console.log(data);

          const { data } = await this.$store.dispatch("builder/getTasklist", {
            // projectName: "testApplication1",
            projectName: process.env.VUE_APP_COMMUNITY_NAME,
          });

          this.taskList = data.map((x) => ({
            text:
              x.name == "Sprint 0" || x.name == "Version 0"
                ? "Default"
                : x.name,
            value: x,
          }));

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  computed: {
    ...mapState("design", ["selectedSprint"]),
    ...mapState("user", ["selectedProject"]),
  },

  async mounted() {
    if (this.selectedRoute == "") {
      this.handleClick(this.cards[0]);
    }
    await this.getTaskList();
    const length = this.taskList.length - 1;
    this.selectedTasklist = this.taskList[length].value;
    await this.$store.commit(
      "design/SET_SELECTED_SPRINT",
      this.selectedTasklist
    );
  },
};
</script>
